// ======================================================================
// File Name       : index
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import authed from './authed';
import serviceLogin from './ServiceLogin';
import service from './service';
import user from './user';
import group from './group';
import container from './container';
import course from './course';
import box from './box';
import superUser from './superuser';
import modal from './modal';
import content from './content';
import question from './question';
import enterprise from './enterprise';
import authority from './authority';
import top from './top';
import editList from './editList';
import importList from './importList';
import message from './message';
import userAttribute from './userAttribute';
import report from './report';
import item from './item';
import contentDistribution from './contentDistribution';
import archivement from './archivement';
import document from './document';
import serviceRecord from './serviceRecord';
import userHistoryContent from './userHistoryContent';
import distributionReport from './distributionReport';
import scoringReport from './scoringReport';
import userHistoryStudent from './userHistoryStudent';
import userHistoryCourse from './userHistoryCourse';
import unsubmittedReport from './unsubmittedReport';
import page from './page';
import initialImage from './initialImage';
import enterpriseNotice from './enterpriseNotice';
import enterpriseNotification from './enterpriseNotification';
import messageThread from './messageThread';
import participant from './participant';
import userHistoryLivePerformance from './userHistoryLivePerformance';
import usageSettingLive from './usageSettingLive';
import adaptive from './adaptive';
import csvDownload from './csvDownload';
import configFile from './configFile';
import email from './email';
import reservedEmail from './reservedEmail';
import { LOGOUT } from '../constants/ActionTypes';
import multiLanguage from './multiLanguage';
import userfrontImage from './userfrontImage';
import tabMenu from './tabMenu';
import usageStatus from './usageStatus';
import serviceGroup from './serviceGroup';
import superuserServiceRole from './superuserServiceRole';
import superuserEnterpriseRole from './superuserEnterpriseRole';

const appReducer = combineReducers({
  form: reduxFormReducer,
  authed,
  serviceLogin,
  service,
  user,
  group,
  container,
  course,
  box,
  modal,
  superUser,
  content,
  question,
  importList,
  enterprise,
  top,
  authority,
  editList,
  message,
  userAttribute,
  report,
  item,
  contentDistribution,
  archivement,
  document,
  serviceRecord,
  userHistoryContent,
  distributionReport,
  scoringReport,
  userHistoryStudent,
  userHistoryCourse,
  unsubmittedReport,
  page,
  initialImage,
  enterpriseNotice,
  enterpriseNotification,
  messageThread,
  participant,
  userHistoryLivePerformance,
  usageSettingLive,
  adaptive,
  csvDownload,
  configFile,
  email,
  reservedEmail,
  multiLanguage,
  userfrontImage,
  tabMenu,
  usageStatus,
  serviceGroup,
  superuserServiceRole,
  superuserEnterpriseRole,
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
